document.addEventListener('DOMContentLoaded', () => {
    new WellnessComponent();
});

class WellnessComponent {
    /**
     * Constructor for WellnessComponent.
     * Finds the `.wellness` element and all `.card` elements inside it.
     * If either of these elements are not found, the constructor does nothing.
     * Otherwise, it sets up an interval to change the active card every 10 seconds.
     */
    constructor() {
        const wellness = document.querySelector('.wellness');

        if (!wellness) {
            return;
        }

        const cards = wellness.querySelectorAll('.card');

        if (!cards || !cards.length) {
            return;
        }

        let currentCard = cards[0],
            currentIndex = 0;

        setInterval(() => {
            if (currentCard) {
                currentCard.classList.remove('active');
                currentCard = null;
            }

            currentIndex++;

            if (currentIndex >= cards.length) {
                currentIndex = 0;
            }

            if (currentCard < 0) {
                currentCard = currentCard.length - 1;
            }

            currentCard = cards[currentIndex];
            currentCard.classList.add('active');
        }, 10000);
    }
}
